import React from 'react';
import ReactApexChart from 'react-apexcharts';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { cores } from '../../../../styles/styleUtils';

const ChartTitle = styled.h3`
  font-size: 1rem;
  color: ${cores.chumbo};
  margin-bottom: 15px;
  text-align: center;
  font-weight: 600;
`;

// This component assumes react-apexcharts is installed
function VerticalBarChart({ chartId, title, options, series, type = 'bar', height = 350, width = '100%' }) {
  return (
    <div>
      {title && <ChartTitle>{title}</ChartTitle>}
      <ReactApexChart
        options={options}
        series={series}
        type={type}
        height={height}
        width={width}
        key={chartId} // Add key for potential re-renders if options/series change drastically
      />
    </div>
  );
}

VerticalBarChart.propTypes = {
  chartId: PropTypes.string.isRequired,
  title: PropTypes.string,
  options: PropTypes.object.isRequired,
  series: PropTypes.array.isRequired,
  type: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default VerticalBarChart;